<section
  class="text-image flex-column-reverse flex-md-row row gx-4"
  [class.invert]="inverse()"
>
  <div class="col-md-6 col-sm-12">
    <h2 *scText="title()"></h2>
    <div class="text-image__text" *wlGenericRichText="content()"></div>
    <div class="text-image__button-container d-flex flex-column flex-md-row">
      @if (showPrimaryButton() && primaryButton(); as primaryButton) {
        <crnt-button-alt class="flex-grow-1 flex-md-grow-0" variant="secondary">
          <a *wlGenericLink="primaryButton"></a>
        </crnt-button-alt>
      }
      @if (showSecondaryButton() && secondaryButton(); as secondaryButton) {
        <crnt-button-alt class="flex-grow-1 flex-md-grow-0" variant="tertiary">
          <a *wlGenericLink="secondaryButton"></a>
        </crnt-button-alt>
      }
    </div>
    @if (showMicrocopy() && microcopy(); as microcopy) {
      <p *scText="microcopy"></p>
    }
  </div>
  <div class="col-md-6 col-sm-12">
    <picture>
      <img *scImage="image()" class="w-100" />
    </picture>
  </div>
</section>
